import PropTypes from 'prop-types'

export const BranchShape = PropTypes.shape({
  message: PropTypes.string,
  type: PropTypes.string
})

export const LocationShape = PropTypes.shape({
  pathname: PropTypes.string.isRequired,
  search: PropTypes.string.isRequired
})

const childMarkdownRemarkShape = PropTypes.shape({
  html: PropTypes.string
})

export const gdprShape = PropTypes.shape({
  childMarkdownRemark: PropTypes.objectOf(childMarkdownRemarkShape)
})



// WEBPACK FOOTER //
// ./src/types/types.js